
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hi/about",
      function () {
        return require("private-next-pages/hi/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hi/about"])
      });
    }
  